let hlsJsPromise: Promise<typeof import("hls.js")> | undefined;

const getHlsJs = async () => {
	if (!hlsJsPromise) {
		hlsJsPromise = import("hls.js");
	}
	return (await hlsJsPromise).default;
};
export default getHlsJs;
